import { render, staticRenderFns } from "./IconLogoAeqRedBaseline.vue?vue&type=template&id=7b6f9f1f&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports